"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootAskAnAgentListSagas = void 0;
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var effects_1 = require("redux-saga/effects");
var AskAnAgentListAction_1 = require("@/pages/askAnAgentList/actions/AskAnAgentListAction");
var AskAnAgentListApiSaga_1 = require("@/pages/askAnAgentList/sagas/api/AskAnAgentListApiSaga");
var questionToAskAnAgentResult_1 = require("@/transformers/questionToAskAnAgentResult");
var WindowApi_1 = require("@/api/browser/WindowApi");
var getCurrentResult = function (state) { return state.askAnAgentList.listResult.results; };
var getSearchKeyword = function (state) { return state.askAnAgentList.searchKeyword || ''; };
var getCurrentUrl = function (state) { return state.askAnAgentList.currentUrl; };
var getCurrentSuggestString = function (state) {
    var suggestions = state.askAnAgentList.suggestions;
    return suggestions[state.askAnAgentList.suggestionSelecting];
};
var getPrevIndex = function (state) {
    var suggestionsCount = state.askAnAgentList.suggestions.length;
    var currentIndex = state.askAnAgentList.suggestionSelecting;
    if (currentIndex <= 0)
        return suggestionsCount - 1;
    return currentIndex - 1;
};
var getNextIndex = function (state) {
    var suggestionsCount = state.askAnAgentList.suggestions.length;
    var currentIndex = state.askAnAgentList.suggestionSelecting;
    if (currentIndex === suggestionsCount - 1)
        return 0;
    return currentIndex + 1;
};
var searchByKeyword = function (keyword, n) {
    var response, responseQuestions, responsePager, newResults;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(AskAnAgentListApiSaga_1.askAnAgentListSearchApi, keyword, n)];
            case 1:
                response = _a.sent();
                responseQuestions = response.data.questions;
                responsePager = response.data.pager;
                newResults = responseQuestions.map(questionToAskAnAgentResult_1.convertQuestionToAskAnAgentResult);
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.updateListResult(newResults, responsePager.currentPage, responsePager.totalPages))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnChangePage = function () {
    var payload, n, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_CHANGE_PAGE)];
            case 1:
                payload = (_a.sent()).payload;
                n = payload;
                return [4 /*yield*/, effects_1.select(getSearchKeyword)];
            case 2:
                keyword = _a.sent();
                return [4 /*yield*/, effects_1.call(searchByKeyword, keyword, n)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.moveTop())];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchMoveTop = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_MOVE_TOP)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.scrollToWindowTop)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnKeywordArrowUp = function () {
    var prevIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_ARROW_UP)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getPrevIndex)];
            case 2:
                prevIndex = _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestionSelecting(prevIndex))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnKeywordArrowDown = function () {
    var nextIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_ARROW_DOWN)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getNextIndex)];
            case 2:
                nextIndex = _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestionSelecting(nextIndex))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOKeywordFocusSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_FOCUS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestionActive(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestionSelecting(-1))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOKeywordBlurSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_BLUR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestionActive(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSetKeywordBlur = function () {
    var action, element;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_SET_BLUR)];
            case 1:
                action = _a.sent();
                element = action.payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.setElementBlur, element)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchDoKeywordSearch = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(AskAnAgentListAction_1.default.ASK_AN_AGENT_DO_KEYWORD_SERACH, function () {
                    var keyword;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.delay(800)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select(getSearchKeyword)];
                            case 2:
                                keyword = _a.sent();
                                return [4 /*yield*/, effects_1.call(searchByKeyword, keyword, 1)];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchDoSuggestion = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(AskAnAgentListAction_1.default.ASK_AN_AGENT_DO_SUGGESTION, function () {
                    var keyword, currentResults, response, suggestions;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.select(getSearchKeyword)];
                            case 1:
                                keyword = _a.sent();
                                if (!(keyword.length < 3)) return [3 /*break*/, 6];
                                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestions([]))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select(getCurrentResult)];
                            case 3:
                                currentResults = _a.sent();
                                if (!(!currentResults || !currentResults.length)) return [3 /*break*/, 5];
                                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.updateListResult(null, 0, 0))];
                            case 4:
                                _a.sent();
                                _a.label = 5;
                            case 5: return [2 /*return*/];
                            case 6: return [4 /*yield*/, effects_1.delay(800)];
                            case 7:
                                _a.sent();
                                return [4 /*yield*/, effects_1.call(AskAnAgentListApiSaga_1.askAnAgentListAutocompleteApi, keyword)];
                            case 8:
                                response = _a.sent();
                                suggestions = response.data && response.data.keywords ? response.data.keywords : [];
                                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestions(suggestions))];
                            case 9:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnKeywordSelect = function () {
    var currentSuggestString;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_SELECT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestString)];
            case 2:
                currentSuggestString = _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setKeyword(currentSuggestString))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.doKeywordSearch())];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setKeywordBlur)];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnSuggestItemClick = function () {
    var payload, currentSuggestString;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_ITEM_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestionSelecting(payload))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestString)];
            case 3:
                currentSuggestString = _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setKeyword(currentSuggestString))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.doKeywordSearch())];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.onKeywordBlur())];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchKeywordChange = function () {
    var action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_SET_KEYWORD)];
            case 1:
                action = _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestionSelecting(-1))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setKeyword(action.payload))];
            case 3:
                _a.sent();
                if (!(action.payload === '')) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.doKeywordSearch())];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.setSuggestions([]))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.doSuggestion())];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchKeywordEnter = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AskAnAgentListAction_1.default.ON_ASK_AN_AGENT_LIST_KEYWORD_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AskAnAgentListAction_1.default.doKeywordSearch())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var rootAskAnAgentListSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchOnChangePage: watchOnChangePage,
    watchMoveTop: watchMoveTop,
    watchOnKeywordArrowUp: watchOnKeywordArrowUp,
    watchOnKeywordArrowDown: watchOnKeywordArrowDown,
    watchOKeywordFocusSaga: watchOKeywordFocusSaga,
    watchOKeywordBlurSaga: watchOKeywordBlurSaga,
    watchSetKeywordBlur: watchSetKeywordBlur,
    watchOnKeywordSelect: watchOnKeywordSelect,
    watchOnSuggestItemClick: watchOnSuggestItemClick,
    watchKeywordChange: watchKeywordChange,
    watchKeywordEnter: watchKeywordEnter,
    watchDoKeywordSearch: watchDoKeywordSearch,
    watchDoSuggestion: watchDoSuggestion,
};
exports.rootAskAnAgentListSagas = rootAskAnAgentListSagas;
